import {ClientNoticeGenqlSelection} from "@/gql/gen";

export const NoticeFields: ClientNoticeGenqlSelection = {
    ID: true,
    TITLE: true,
    MESSAGE: true,
    BODY: true,
    CREATED_AT: true,
    EVENT_DATA: true,
    EVENT_GROUP: true,
    EVENT_NAME: true,
    IMAGE: {
        __fragment: "Image"
    },
    SHOW_AS: true,
}
